import { printLine, parseStyledString } from "../utilities.js";
import { screen } from "../screen.js";

export const program = {
    name: "contact",
    size: 27, // Number of lines of this 'program'
    list: async () => {
        await printLine("16 SYS 1822"); // Simulate the 'list' command when this program is loaded
    }, 
    run: async () => {
        await screen.clearScreen();
        await printLine();
        await printLine(parseStyledString("[fg=white]***[/] [fg=yellow]!CONTACT ME![/] [fg=white]***[/]"), { align: 'center' });
        await printLine();
        await printLine();
        await printLine(parseStyledString("[fg=white]W   :[/]               [fg=yellow]www.dss-solutions.nl[/]"));
        await printLine();
        await printLine(parseStyledString("[fg=white]E   :[/]              [fg=yellow]info@dss-solutions.nl[/]"));
        await printLine();
        await printLine(parseStyledString("[fg=white]LI  :[/] [fg=yellow]linkedin.com/company/dss-solutions[/]"));
        await printLine();
        await printLine(parseStyledString("[fg=white]STPS:[/][fg=yellow]www.shoot-the-penguin-studios.games[/]"));
        await printLine();
        await printLine();
        await printLine(parseStyledString("[fg=white]***[/] [fg=yellow]!CONTACT ME![/] [fg=white]***[/]"), { align: 'center' });
    }
};